import _axios from "@/plugins/axios";


export default{
    getGoods() {
        return _axios({
            url:'v1/api/goods',
            method: 'post',
            data:{type:4}
        })
    },
    getShopList(data) {
        return _axios({
            url:'v1/api/shop',
            method: 'post',
            data:data
        })
    },
    getShopDetail(pid) {
        return _axios({
            url:'v1/api/shopDetail',
            method: 'post',
            data:{pid:pid}
        })
    },
    getArea(pid){
        return _axios({
            url:'v1/api/area',
            method: 'post',
            data:{pid:pid}
        })
    }
}